export enum GOOD_OFFER_IDS {
  WEBBANKIR = '5e95c820380d2c001c873e36',
  ZAJMIGO = '5e95ed47380d2c001c873e46',
  EKAPUSTA = '5e95bb2921f302001b3230a3',
  KVIKU = '5e622bc255e6a6001b03fab8',
  MONEYMAN = '5e5fbbef55e6a6001b03fab6',
}
